<custom-modal
  modalClass="poa-required-modal"
  [(open)]="open"
  [header]="'LABELS.POA_REQUIRED_MODAL.TITLE'"
  [isListenClose]="true"
  (closeClick)="onDiscard()"
  (openChange)="openChange.emit($event)"
>
  <div class="poa-required-modal__content">
    <div class="poa-required-modal__icon-container">
      <span class="poa-required-modal__icon">!</span>
    </div>
    <div class="poa-required-modal__text">
      <p>{{ "LABELS.POA_REQUIRED_MODAL.BODY_LINE_1" | translate }}</p>
      <p>{{ "LABELS.POA_REQUIRED_MODAL.BODY_LINE_2" | translate }}</p>
    </div>
  </div>
  <div class="poa-required-modal__actions">
    <button footer-action type="button" class="btn btn-outline-bordered btn-square" (click)="onDiscard()">
      {{ "BUTTON.DISCARD" | translate }}
    </button>
    <button footer-action type="button" class="btn btn-primary btn-square" (click)="onGoToPoa()">
      {{ "LABELS.POA_REQUIRED_MODAL.CTA" | translate }}
    </button>
  </div>
</custom-modal>
